import { css } from "emotion";
import { Popover } from "@certa/catalyst/components/Popover";
import {
  Tag,
  TagVariants,
  type TagSizes
} from "@certa/catalyst/components/Tag";
import type { Badge, BadgeUIMode } from "@certa/types";
import { BadgePopoverContent } from "./BadgePopoverContent";
import { computeBadgeIconAndColor } from "./utils/computeBadgeIconAndColor";
import { Stack } from "@certa/catalyst/layouts/Stack";

export const BadgeComponent = ({
  badge,
  size,
  modeOverride
}: {
  badge: Badge;
  size: TagSizes;
  modeOverride: BadgeUIMode | undefined;
}) => {
  const { icon, color, badgeMode } = computeBadgeIconAndColor(badge, {
    modeOverride
  });

  const triggerProps = false
    ? ({
        trigger: "hover",
        ariaDescription: badge.helpText
      } as const)
    : ({
        trigger: "click"
      } as const);

  return (
    <Stack
      dangerouslySetClassName={css({
        flexShrink: 0
      })}
    >
      <Popover
        key={badge.tag}
        openInPortal
        placement="bottom-end"
        showArrow={true}
        {...triggerProps}
        content={<BadgePopoverContent badge={badge} />}
      >
        <Tag
          key={badge.tag}
          variant={TagVariants.FILLED}
          size={size}
          type={badgeMode === "icon" ? "Icon" : "Text"}
          color={color}
          icon={icon}
          label={badge.name}
        >
          {badgeMode === "icon" ? null : badge.name}
        </Tag>
      </Popover>
    </Stack>
  );
};
